import { ArrowLeft } from 'lucide-react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface ReleaseNotesListHeaderProps {
  onBack: () => void;
}

const ReleaseNotesListHeader: FC<ReleaseNotesListHeaderProps> = ({ onBack }) => {
  const { t } = useTranslation();

  return (
    <div className="shrink-0 flex items-center gap-2 px-4 py-4">
      <Button variant="ghost" size="icon" className="size-8" onClick={onBack} aria-label="back">
        <ArrowLeft className="size-5" />
      </Button>
      <h2 className="text-base font-semibold">{t('menu.release_notes')}</h2>
    </div>
  );
};

export default ReleaseNotesListHeader;
